<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-sms-simple-body">
            <span class="dw-sms-provider-badge dw-sms-provider-badge--blue">{{ providerName() }}</span>
            <div class="dw-sms-simple-hero">
                <span class="dw-sms-simple-num">{{ remaining }}</span>
                <span class="dw-sms-simple-unit">SMS</span>
            </div>
            <div class="dw-sms-simple-label">Kalan Bakiye</div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'sms_credit_simple',
    titleKey: 'common.dashboard.widgetTitles.sms_credit_simple',
    icon: 'bi-chat-left-text',
    accent: '#3B82F6',
    accentBg: 'rgba(59, 130, 246, 0.12)',
    glassRgb: '59, 130, 246',
    defaultCol: 1,
    defaultRow: 1,
    multiInstance: true,
    source: { type: 'module', moduleCode: 'VERIMOR', code: 'BALANCE' },
    defaultConfig: { provider: 'VERIMOR' },
    configFields: [
        { key: 'provider', label: 'common.dashboard.widgetFields.provider', type: 'sms_provider_select' },
    ],
};

export default {
    name: 'SmsCreditSimpleWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        remaining() {
            const items = this.apiData?.items || [];
            const credit = items.find(i => i.type === 'SMS_CREDIT');
            const raw = credit?.amount ?? '0';
            const n = parseInt(String(raw).replace(/[^\d]/g, ''), 10) || 0;
            return n.toLocaleString('tr-TR');
        },
    },
};
</script>
